import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * JP-mode preferences — drives the workspace's JP UX widgets:
 *   • `wareki` — render dates as 元号 (令和7年) instead of 2025.
 *   • `numericUnit` — 'unit' shows 千/百万/億; 'wide' shows full-width
 *     digits (１２３); 'plain' is standard western digits.
 *   • `furigana` — when true, components that have a `furigana` prop
 *     render the ruby annotation above the kanji.
 *   • `keigoRegister` — default 敬語 register for Compose:
 *     `formal-first | formal-followup | introduced | friendly`.
 *
 * Persisted to localStorage so the user's choices follow them across
 * tabs / reloads.
 */
export type NumericUnit = 'plain' | 'unit' | 'wide';
export type KeigoRegister = 'formal-first' | 'formal-followup' | 'introduced' | 'friendly';

interface JpModeState {
  wareki: boolean;
  numericUnit: NumericUnit;
  furigana: boolean;
  keigoRegister: KeigoRegister;
  setWareki: (v: boolean) => void;
  setNumericUnit: (v: NumericUnit) => void;
  setFurigana: (v: boolean) => void;
  setKeigoRegister: (v: KeigoRegister) => void;
}

export const useJpMode = create<JpModeState>()(
  persist(
    (set) => ({
      wareki: false,
      numericUnit: 'plain',
      furigana: false,
      keigoRegister: 'formal-first',
      setWareki: (v) => set({ wareki: v }),
      setNumericUnit: (v) => set({ numericUnit: v }),
      setFurigana: (v) => set({ furigana: v }),
      setKeigoRegister: (v) => set({ keigoRegister: v }),
    }),
    { name: 'knowlez-jp-mode' },
  ),
);
